import { store } from '../../store';
import { updateQueue } from '../../ReduxSlices/Patients/patientQueueSlice';
import { upsertPatient } from '../../ReduxSlices/Patients/patientSlice';
import subscribeToCoreUpdates from '../core_updates_channel';

let unsubscribePatientQueue = null; // store unsubscribe function

export const initializePatientQueueSubscription = () => {
  if (unsubscribePatientQueue) return; // already subscribed

  // Subscribe via CoreUpdatesChannel with a unique module key
  unsubscribePatientQueue = subscribeToCoreUpdates("patientQueue", {
    "patient_queue.updated": ({action, entry}) => {
    
      store.dispatch(updateQueue({ actionType: action, entry }));

      if (entry?.patient) {
        store.dispatch(upsertPatient(entry.patient));
      }
    }
  });

 // console.log("✅ PatientQueue subscription initialized");
};

export const unsubscribePatientQueueSubscription = () => {
  if (unsubscribePatientQueue) {
    unsubscribePatientQueue(); // remove only PatientQueue handlers
    unsubscribePatientQueue = null;
   // console.log("🔌 PatientQueue subscription removed");
  }
};